module.exports = __webpack_public_path__ + "static/media/ahmad_fauzi.70c4d15e.jpg";